<template>
    <b-row>
        <b-col md="12">
            <b-card
                no-body
            >
                <b-card-header>
                    <b-card-title class="d-flex justify-content-start">
                        <div class="mr-1 line-height-1">
                            <feather-icon class="text-warning" size="17" icon="HardDriveIcon" />
                        </div>
                            {{ $t('org.auth.loginHistory') }}
                    </b-card-title>
                </b-card-header>
                <template v-if="logHistory.length > 0">
                    <b-card-body>
                        <b-table
                            responsive
                            striped
                            :items="logHistory"
                            :fields="historyColumns"
                            class="mb-0 position-relative"
                            :per-page="perPage"
                            :current-page="currentPage"
                        >
                            <template #cell(result)="data">
                                <div :class="`text-${stateColor(data.item.result)}`">{{ data.item.result }}</div>
                            </template>
                            <template #cell(serviceGroup)="data">
                                <div>{{ data.item.serviceGroup.toUpperCase() }}</div>
                            </template>
                            <template #cell(loginDate)="data">
                                <div>
                                    <div>{{ dateParse(data.item.loginDate) }}</div>
                                </div>
                            </template>
                        </b-table>
                    </b-card-body>
                    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                        <!-- page length -->
                        <b-form-group
                            label="Per Page"
                            label-cols="6"
                            label-align="left"
                            label-size="sm"
                            label-for="sortBySelect"
                            class="text-nowrap mb-md-0 mr-1 custom-footer-label custom-css"
                        >
                            <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
                        </b-form-group>

                        <!-- pagination -->
                        <div>
                            <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            first-number
                            last-number
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mb-0"
                            >
                                <template #prev-text>
                                    <feather-icon icon="ChevronLeftIcon" size="18" />
                                </template>
                                <template #next-text>
                                    <feather-icon icon="ChevronRightIcon" size="18" />
                                </template>
                            </b-pagination>
                        </div>
                    </b-card-body>
                </template>
                <b-card-body v-else>
                    <div style="text-align:center">{{ $t('org.auth.There is no login history') }}</div>
                </b-card-body>
            </b-card>
        </b-col>
        <b-col md="12" v-if="stateFlag" class="pt-3">
            <div style="text-align:center">
                <b-spinner label="Loading..." />
            </div>
        </b-col>
    </b-row>
</template>

<script>
import { ref, computed, getCurrentInstance } from '@vue/composition-api'
export default {
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        /* data */
        const perPage = ref(10)
        const pageOptions = [10, 25, 50]
        let totalRows = ref(1)
        let currentPage = ref(1)
        const stateFlag = ref(false)
        const historyColumns = [
            {
                label: 'Result',
                key: 'result'
            },
            {
                label: 'Service Group',
                key: 'serviceGroup'
            },
            {
                label: 'IP',
                key: 'ip'
            },
            {
                label: 'Login Date',
                key: 'loginDate'
            }
        ]

        /* computed */
        const authUserInfo = computed(() => store.getters.authUserInfo)
        const logHistory = computed(() => store.getters.logHistory)

        /* methods */
        const dateParse = (date) => {
            const KR_TIME_DIFF = 9 * 60 * 60 * 1000
            const krDate = new Date(Date.parse(date.replace(' ', 'T')) + KR_TIME_DIFF)
            return krDate.getFullYear() + '-' + (krDate.getMonth() + 1) + '-' + krDate.getDate() + ' ' + krDate.getHours() + ':' + krDate.getMinutes() + ':' + krDate.getSeconds()
        }
        const stateColor = (state) => {
            if (state === 'SUCCESS') {
                return 'success'
            } else if (state === 'FAILED') {
                return 'danger'
            } else {
                return 'primary'
            }
        }

        /* init */
        stateFlag.value = true
        store.dispatch('getUserSigninHistory', { userIdx: authUserInfo.value.userIdx }).then((response) => {
            if (response.status === 'OK') {
                totalRows.value = response.data.length
            }
            stateFlag.value = false
        })

        return {
            perPage,
            pageOptions,
            totalRows,
            currentPage,
            stateFlag,
            historyColumns,
            logHistory,
            dateParse,
            stateColor
        }
    }
}
</script>

<style>
.custom-css > label {
    margin: auto 0
}
</style>
